'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import { useRouter as useTopLoaderRouter } from 'nextjs-toploader/app';

export const useAppRouter = (type: 'next' | 'topLoader' = 'topLoader') => {
  const nextRouter = useRouter();
  const topLoaderRouter = useTopLoaderRouter();

  const router = React.useMemo(() => {
    const options = {
      next: nextRouter,
      topLoader: topLoaderRouter,
    };
    return options[type] || nextRouter;
  }, [type, nextRouter, topLoaderRouter]);

  return router;
};
